import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../slice'
import createInvoicesSlice, { InvoicesSlice } from './invoices/slice'
import createInvoiceSlice, { InvoiceSlice } from './invoices/edit/slice'
import createSharedStockSlice, { SharedStockSlice } from './slice'

const useStockStore = create<
  InvoicesSlice & InvoiceSlice & SharedSlice & SharedStockSlice
>()((...props) => ({
  ...createSharedSlice(...props),
  ...createSharedStockSlice(...props),
  ...createInvoicesSlice(...props),
  ...createInvoiceSlice(...props),
}))

export default useStockStore
